import React from 'react'
import Navbar from '../components/Navbar'

const ProfileCluster = () => {
  return (
    <div>
      ProfileCluster
    </div>
  )
}


export default ProfileCluster
